import * as _ from 'lodash'
import moment from 'moment'

import Pagination, {
  Page
} from '../../components/pagination';
import Statements from '../../services/statements';
import messageDialog from '../../components/message-dialog.vue';
import * as F from '../../filters/date';
import {
  beforeOneYear
} from '../../validators/date';

const lastDaysOptions = [{
  value: '15',
  caption: 'Últimos 15 dias'
},
{
  value: '30',
  caption: 'Últimos 30 dias'
},
{
  value: 'custom',
  caption: 'Período personalizado'
},
];
// {
//     value: '60',
//     caption: 'Últimos 60 dias'
//   },
//   {
//       value: '90',
//       caption: 'Últimos 90 dias'
//     },

const pageSizeOptions = [{
  value: 20,
  caption: '20'
},
{
  value: 40,
  caption: '40'
},
{
  value: 60,
  caption: '60'
},
{
  value: 80,
  caption: '80'
},
{
  value: 100,
  caption: '100'
},
];

export default {
  data() {
    return {
      // últimos N dias ou 'custom'
      lastDays: '15',

      lastDaysOptions,
      pageSizeOptions,

      // Se 'custom' a data inicial
      customStart: undefined,

      // Se 'custom' a data final
      customEnd: undefined,

      // Promise para indicar carregamento
      loading: Promise.resolve(true),

      // Objeto com estado de paginação
      page: new Page(),

      // Resultado da requisição para tabela
      data: {
        statements: undefined,
        summary: undefined
      },

      searchState: 'NEW',
      downloadStatementUrl: undefined,
      plate: undefined,
      showPlate: false,
      messageError: undefined,
      listTransactionRefund: [],
      rowIsOpen: {},
      plan: this.$route.params.planId,
      canDownloadConsolidated: false,
      downloadingConsolidated: false
    }
  },

  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
    tutorial() {
      switch (parseInt(this.$route.params.planId)) {
        case 28:
        case 39:
          return '/api/v2/archeion/downloadFileArcheion/move-mais-entenda-seu-extrato-pos-pago';
        case 33:
          return '/api/v2/archeion/downloadFileArcheion/move-mais-entenda-seu-extrato-move-pague';
        default:
          return '/api/v2/archeion/downloadFileArcheion/move-mais-entenda-seu-extrato-pre-pago';
      }
      return this.$route.params.planId;
    },
    /** Calcula a data inicial do relatório **/
    periodStart() {
      let days = this.lastDays;
      let d = (days == 'custom') ?
        moment(this.customStart) :
        moment().subtract(parseInt(days), 'd');

      return d.startOf('day').valueOf();
    },

    /** Calcula a data final do relatório **/
    periodEnd() {
      let days = this.lastDays;
      let d = (days == 'custom') ?
        moment(this.customEnd) :
        moment();

      return d.endOf('day').valueOf();
    },


  },

  watch: {
    showPlate(newValue) {
      if (!newValue)
        this.plate = undefined;
      this.invalidateConsolidatedDownload();
    },
    lastDays() {
      this.invalidateConsolidatedDownload();
    },
    customStart() {
      this.invalidateConsolidatedDownload();
    },
    customEnd() {
      this.invalidateConsolidatedDownload();
    },
    plate() {
      this.invalidateConsolidatedDownload();
    },
  },
  mounted: function () { },
  methods: {
    invalidateConsolidatedDownload() {
      this.canDownloadConsolidated = false;
    },
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.doFilter();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.doFilter();
    },
    validate() {
      let error = this.errors;
      //this.searchState = 'NEW';
      let filter = {
        contractId: this.$route.params.contractId,
        startDate: this.periodStart,
        endDate: this.periodEnd,
        page: this.page.build(),
        plate: this.plate
      };
      if (this.plate) {
        this.showPlate = true;
      }

      if (this.lastDays == 'custom' && (!this.customStart || !this.customEnd || (this.customStart > this.customEnd))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = (this.customStart && this.customEnd) ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!'
        return false;
      }

      // if (this.lastDays == 'custom' && beforeOneYear.validate(moment(this.customStart).format("L"))) {
      //   this.searchState = 'ERROSEARCH';
      //   this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
      //   return false;
      // }

      if (this.lastDays == 'custom' && this.customStart && this.customEnd && ((this.customEnd - this.customStart) > (2678400000))) {
        //2678400000 = 31 dias
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período máximo permitido, 31 dias.';
        return false;
      }

      return filter;
    },
    doFilter(clearCache) {
      let filter = this.validate()
      if (clearCache) {
        this.listTransactionRefund = [];
        filter.page = 1;
        this.page = filter.page = this.page.page(1);
      }

      if (filter) {
        this.canDownloadConsolidated = false;
        Statements.getSummary(filter).then(res => {

          this.data.summary = res;
        });

        let promise = Statements.find(filter).then(data => {




          this.data.statements = data;
          if (this.data.statements.total) {
            this.searchState = 'FOUND';
            this.canDownloadConsolidated = true;
            this.page = this.page.itemCount(data.total);
            this.$nextTick(() => {
              $('[data-toggle="tooltip"]').tooltip();
              $('html, body').stop().animate({
                scrollTop: $("#resumeTable").offset().top - 110
              }, 1000);
            });
          } else {
            this.searchState = 'NOTFOUND';
            this.canDownloadConsolidated = false;
          }


        })
          .catch(err => {
            this.searchState = 'NOTFOUND';
            this.canDownloadConsolidated = false;
          });
        this.$store.dispatch('loading', promise);
      }


    },

    doFilterDownload() {
      if (!this.canDownloadConsolidated || this.downloadingConsolidated) {
        return;
      }
      let filter = this.validate()
      if (filter) {
        this.downloadingConsolidated = true;
        Statements.findExtratoConsolidado(filter).then(data => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          //link.href = 'data:attachment/xlsx,' + encodeURI(data);
          link.target = '_blank';
          link.download = 'Extrato_' + filter.contractId + '.xlsx';
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          this.downloadingConsolidated = false;
        }).catch(err => {
          this.downloadingConsolidated = false;
          return messageDialog.show({
            title: 'Falha ao emitir o relatório',
            message: err.data.status.message,
            type: 'OK'
          });
        });
      }
    },

    numberClass(summary) {
      return (summary.type == 'C') ? 'green' : (summary.type == 'S') ? 'black' : 'red';
    },
    downloadExtractFile(type) {
      let win = window;
      let filter = this.validate();
      if (filter) {
        messageDialog.show({
          title: 'Exportar dados',
          message: 'Selecione para qual formato deseja exportar:',
          type: 'DOWNLOAD',
          statement: {
            contract: this.$route.params.contractId,
            startDate: this.periodStart,
            endDate: this.periodEnd,
            filter: this.plate,
            transactions: this.listTransactionRefund.length > 0 && type !== 'full' ? this.listTransactionRefund.toString() : null
          }
        });
      }
    },
    download(res) {
      this.downloadStatementUrl = `/api/v1/statement/${res}/${this.$route.params.contractId}/${this.periodStart}/${this.periodEnd}`;
      if (this.plate)
        this.downloadStatementUrl += `/${this.plate}`;
      let transaction = this.listTransactionRefund.length > 0 ? this.listTransactionRefund.toString() : null;

      var aTag = window.document.getElementById('mobi');
      aTag.setAttribute('href', this.downloadStatementUrl);
      aTag.setAttribute('download', 'teste.xls');
      // aTag.style.display = "none";
      // aTag.innerHTML = "";
      // mydiv.appendChild(aTag);
      aTag.click();
    },
    b64EncodeUnicode(str) {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
    },
    getValueClass(t) {
      if (parseInt(t.idHistoric) == 99)
        return "";
      return t.type == 'C' ? 'green' : 'red';
    },
    checkPlan() {
      if (this.plan != 23 && this.plan != 24 && this.plan != 28 && this.plan != 39 && this.plan != 8) {
        return true;
      }
    },
    getClassIcon(t) {
      switch (parseInt(t.idHistoric)) {
        /* Bloqueio Caução */
        case 1:
          return 'icon-not-allowed red'
        /* Desbloqueio Caução */
        case 2:
          return 'icon-checkmark-outline green'
        /* Saldo */
        case 99:
          return 'icon-notification yellow'
        /* Pagamento Adesão */
        case 1001:
          return 'icon-coin green'
        /* Pagamento Taxa de Recarga */
        case 1002:
          return 'icon-coin green'
        /* Pagamento Adesão Veículo Adicional */
        case 1003:
          return 'icon-coin green'
        /* Pagamento Substituição de TAG */
        case 1004:
          return 'icon-coin green'
        /* Pagamento Taxa por Utilização */
        case 1005:
          return 'icon-coin green'
        /* Pagamento Taxa de Recarga */
        case 1006:
          return 'icon-coin green'
        /* Pagamento Passagem */
        case 1007:
          return 'icon-coin green'
        /* Pagamento Taxa de Reativação */
        case 1008:
          return 'icon-coin green'
        /* Adesão */
        case 1010:
          return 'icon-plans blue'
        /* Estorno Adesão */
        case 2010:
          return 'icon-reply blue'
        /* Pagamento Crédito Automático */
        case 1012:
          return 'icon-coin green'
        /* Adesão Veículo Adicional */
        case 1067:
          return 'icon-add-vehicle blue'
        /* Taxa de Substituição de TAG */
        case 1075:
          return 'icon-sync blue'
        /* Taxa de Recarga */
        case 1078:
          return 'icon-percentage purple'
        /* Passagem */
        case 1101:
          return 'icon-toll red'
        /* Estorno Passagem */
        case 2101:
          return 'icon-reply blue'
        /* Recarga */
        case 1270:
          return 'icon-coin green'

        /* Recarga Vale-pedágio */
        case 1313:
          return 'icon-coin green'

        /* Transferência Vale-pedágio */
        case 1314:
          return 'icon-coin green'

        /* Mensalidade */
        case 1332:
          return 'icon-calendar yellow'

        /* Juros */
        case 1401:
          return 'icon-percentage purple'

        /* Multa */
        case 1501:
          return 'icon-percentage purple'

        /* Estorno Mensalidade */
        case 2332:
          return 'icon-reply blue'

        /* Taxa por Utilização */
        case 1668:
          return 'icon-percentage purple'

        /* Desconto */
        case 1669:
          return 'icon-percentage purple'

        /* Desconto Adesão */
        case 1671:
          return 'icon-percentage purple'

        /* Caução */
        case 1371:
          return 'icon-coin green'
      }
      return "icon-move-plus gray";
    },
    toogleRow(id) {
      if (this.rowIsOpen[id])
        this.rowIsOpen[id] = false;
      else
        this.$set(this.rowIsOpen, id, true);
    },
    exportarExtratoConsolidado() {
      if (this.plate.length == 7) {
        let placa = this.plate;
        this.plate = placa.replace(/(\w{3})(\d{4})/g, '$1-$2');

      }

      let filter = {
        // contractId: this.$route.params.contractId,
        endDate: F.date(this.periodEnd, 'YYYY-MM-DD'),
        startDate: F.date(this.periodStart, 'YYYY-MM-DD'),
        plate: this.plate
      }

      let promise = Statements.exportarExtratoConsolidado(filter).then(data => {
        //
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ExtratoConsolidado_' + filter.plate + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }).catch(err => {
        return messageDialog.show({
          title: 'Falha ao emitir o relatório',
          message: err.data.status.message,
          type: 'OK'
        });
      });
      this.$store.dispatch('loading', promise);
    }
  },

  filters: {
    plate(value) {
      if (!value) return value;
      return value.substring(0, 3) + " - " + value.substring(3);
    },
    local(value) {
      let p = /.*km[\s0-9]*/.exec(value);
      if (p && p.length > 0)
        return p[0];
      else
        return value;
    },
    barWrap(value) {
      return value.split("/").join(' / ');
    }
  },
  components: {
    Pagination
  }
}

const dataUri = {
  pdf: {
    data: 'data:application/pdf;base64,',
    fileName: 'extrato.pdf'
  },
  excel: {
    data: 'data:application/xls;base64,',
    fileName: 'extrato.xls'
  },
  json: {
    data: 'data:application/txt;charset=utf-8,',
    fileName: 'extrato.json'
  }


}



// WEBPACK FOOTER //
// ./src/pages/account/statement.js